import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/AuthContext";
import RequireAdmin from "@/auth/RequireAdmin";

import Home from "@/pages/Home";
import Sky from "@/pages/Sky";
import MemorialDetail from "@/pages/MemorialDetail";
import MemorialCreate from "@/pages/MemorialCreate";
import MemorialEdit from "@/pages/MemorialEdit";
import Fund from "@/pages/Fund";
import FundApply from "@/pages/FundApply";
import Adoption from "@/pages/Adoption";
import AdoptionDetail from "@/pages/AdoptionDetail";
import AdoptionSubmit from "@/pages/AdoptionSubmit";
import AdoptionEdit from "@/pages/AdoptionEdit";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";

function App() {
    useEffect(() => {
        document.documentElement.classList.add("dark");
    }, []);

    return (
        <div className="App night-sky">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/taubenhimmel" element={<Sky />} />
                        <Route path="/taubenhimmel/bearbeiten/:token" element={<MemorialEdit />} />
                        <Route path="/taubenhimmel/:slug" element={<MemorialDetail />} />
                        <Route path="/erstellen" element={<MemorialCreate />} />
                        <Route path="/himmelsfonds" element={<Fund />} />
                        <Route path="/himmelsfonds/hilfe" element={<FundApply />} />
                        <Route path="/vermittlung" element={<Adoption />} />
                        <Route path="/vermittlung/inserat-aufgeben" element={<AdoptionSubmit />} />
                        <Route path="/vermittlung/bearbeiten/:token" element={<AdoptionEdit />} />
                        <Route path="/vermittlung/:id" element={<AdoptionDetail />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route
                            path="/admin/*"
                            element={
                                <RequireAdmin>
                                    <AdminDashboard />
                                </RequireAdmin>
                            }
                        />
                        <Route path="/impressum" element={<Impressum />} />
                        <Route path="/datenschutz" element={<Datenschutz />} />
                        <Route path="/agb" element={<AGB />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
            <Toaster
                position="top-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0c1222",
                        color: "#f8fafc",
                        border: "1px solid rgba(240, 198, 116, 0.3)",
                        borderRadius: "12px",
                    },
                }}
            />
        </div>
    );
}

export default App;
